import { emailRegex } from '@whoop/web-components';
import { InviteFlowReducerState, InviteFlowReducerAction, InvalidEmailEntry } from './types';

// TODO: Consolidate this with src/login/index.jsx
export const isEmail = (email: string) => emailRegex.test(email);

export const parseEmails = (text: string) => {
  const whitespaceToCommas = text.trim().replace(/\s/g, ',');
  const possibleEmails = whitespaceToCommas.split(/,+/);
  const distinctPossibleEmails = possibleEmails.filter(
    (value, index, self) => self.indexOf(value) === index,
  );
  return distinctPossibleEmails.reduce(
    (acc, possibleEmail) => {
      if (!possibleEmail.length) {
        return acc;
      }
      if (isEmail(possibleEmail)) {
        acc.validParsedEmails = acc.validParsedEmails.concat(possibleEmail);
      } else {
        acc.invalidParsedEmails = acc.invalidParsedEmails.concat(possibleEmail);
      }
      return acc;
    },
    { validParsedEmails: [], invalidParsedEmails: [] },
  );
};

export const checkEmail = (emails: string[], email: string) => {
  let error = '';

  if (emails.includes(email)) {
    error = `${email} has already been added.`;
  }

  if (!isEmail(email)) {
    error = `${email} is not a valid email address.`;
  }

  return error;
};

const INVALID_EMAILS_CODE = 'INVALID_EMAILS';
const GENERIC_ERROR_MESSAGE = 'Something went wrong. Please try again.';

export const getApiErrorMessage = (e: any): string => {
  const data = e?.response?.data;
  if (typeof data === 'string') {
    return GENERIC_ERROR_MESSAGE;
  }
  if (typeof data?.message === 'string' && data.message) {
    return data.message;
  }
  if (typeof e?.message === 'string' && e.message) {
    return e.message;
  }
  return GENERIC_ERROR_MESSAGE;
};

export const getInvalidEmailErrors = (e: any): InvalidEmailEntry[] | null => {
  const data = e?.response?.data;
  if (data?.code !== INVALID_EMAILS_CODE || !Array.isArray(data.invalid_emails)) {
    return null;
  }
  const entries: InvalidEmailEntry[] = data.invalid_emails
    .filter((entry: any) => Number.isInteger(entry?.index) && entry.index >= 0)
    .map(({ index, reason }: InvalidEmailEntry) => ({ index, reason }));
  return entries.length ? entries : null;
};

export const inviteFlowReducer = (
  state: InviteFlowReducerState,
  action: InviteFlowReducerAction,
): InviteFlowReducerState => {
  switch (action.type) {
    case 'setShippingMethod':
      return {
        ...state,
        shippingMethod: action.shippingMethod,
      };
    default:
      return state;
  }
};
